import JitsiMeetJS from '../lib-jitsi-meet';
import { useBaseStore, useConfigStore } from '../store';
import { runOnce } from '../utils/run-once-hof';

export function areDevicesDifferent(
  existingDevices: MediaDeviceInfo[] = [],
  newDevices: MediaDeviceInfo[] = [],
) {
  if (existingDevices.length !== newDevices.length) {
    return true;
  }

  for (let existingDevice of existingDevices) {
    const found = newDevices.find(
      ({ deviceId, groupId, kind, label }) =>
        existingDevice.deviceId === deviceId &&
        existingDevice.groupId === groupId &&
        existingDevice.kind === kind &&
        existingDevice.label === label,
    );

    if (!found) {
      return true;
    }
  }

  return false;
}

function isLabelEmpty() {
  const audioInputDevices = useBaseStore.getState().audioInputDevices;
  const videoInputDevices = useBaseStore.getState().videoInputDevices;
  const devices = [...audioInputDevices, ...videoInputDevices];
  const sessionType = useConfigStore.getState().sessionType;
  if (
    devices
      .filter(device => device.kind === 'audioinput' || sessionType === 'VIDEO')
      .some(device => device.label === '')
  ) {
    return true;
  }
  return false;
}

export function updateInputOutputDevices(onlyUpdateIfLabelIsEmpty = false) {
  if (onlyUpdateIfLabelIsEmpty && isLabelEmpty()) {
    return;
  }

  const { mediaDevices } = JitsiMeetJS;

  if (mediaDevices.isDeviceChangeAvailable()) {
    mediaDevices.enumerateDevices((devices: MediaDeviceInfo[]) => {
      const audioInputDevices = devices.filter(
        (device): device is MediaDeviceInfo & { kind: 'audioinput' } =>
          device.kind === 'audioinput' && device.deviceId !== '',
      );
      const audioOutputDevices = devices.filter(
        (device): device is MediaDeviceInfo & { kind: 'audiooutput' } =>
          device.kind === 'audiooutput' && device.deviceId !== '',
      );
      const videoInputDevices = devices.filter(
        (device): device is MediaDeviceInfo & { kind: 'videoinput' } =>
          device.kind === 'videoinput' && device.deviceId !== '',
      );
      useBaseStore.setState({
        audioInputDevices: audioInputDevices,
        audioOutputDevices: audioOutputDevices,
        videoInputDevices: videoInputDevices,
      });
    });
  }
}

function _initDeviceList() {
  const { mediaDevices } = JitsiMeetJS;
  mediaDevices.addEventListener(
    JitsiMeetJS.events.mediaDevices.DEVICE_LIST_CHANGED,
    (devices: MediaDeviceInfo[]) => {
      const existingAudioInputDevices = useBaseStore.getState()
        .audioInputDevices as MediaDeviceInfo[];
      const existingAudioOutputDevices = useBaseStore.getState()
        .audioOutputDevices as MediaDeviceInfo[];
      const existingVideoInputDevices = useBaseStore.getState()
        .videoInputDevices as MediaDeviceInfo[];
      const existingDevices = existingAudioInputDevices.concat(
        existingAudioOutputDevices,
        existingVideoInputDevices,
      );
      setTimeout(() => {
        if (areDevicesDifferent(existingDevices, devices)) {
          updateInputOutputDevices();
        }
      }, 0);
    },
  );

  updateInputOutputDevices();
}

export const initDeviceList = runOnce(_initDeviceList);
